export const homeObjOne = {
	id: 'about',
	LightBg: false,
	lighttext: true,
	lightTextDesc: true,
	topLine: 'Who am I?',
	headline: 'From the Jobsite, to the Website',
	description: `I started my journey in software development thanks to the guidance and training of Code Tenderloin and the esteemed Rithm School. After years of working my way from Laborer to Lead Supervisor in the construction field, I wanted to finally explore my life-long passion for tech and apply it to a new career. While I am not a typical software engineering applicant,  I bring a unique resilience and determination as a developer who broke into the field without a formal college degree.  
	`,
	descriptionTwo: ` When I finished my Rithm School training, I landed a job as a Front-End Developer for Vintage Wine Estates, a company based in Santa Rosa. In that role, I gained invaluable experience working with a team, including my fellow developers as well as marketing and e-commerce staff. During my time with Vintage Wine Estates, I implemented multiple site redesigns, gained a strong understanding of accessibility and search engine optimization, and created enhancements on many of our flagship sites to increase customer retention.`,
	descriptionThree: `A little bit about me outside of work: I love my family and my two kids, moving my body outside, and nerding out to my favorite trading card games.`,

	buttonLabel: 'My skills',
	imgStart: false,
	// img: require('../../images/about-me.png').default,
	alt: 'look in the mirror',
	dark: true,
	primary: true,
	darktext: false,
};